/**
 * BeheardShellLayout
 *
 * Conditional layout wrapper:
 * - When isShellEnabled() → renders shared SuiteShell (header + left nav + outlet)
 * - Otherwise           → renders legacy MainLayout (unchanged fallback)
 *
 * Shell is enabled only when:
 *   authSource === 'central' AND meta.features.uiShell === true
 *   (or VITE_FORCE_UI_SHELL=true for local dev)
 */

import { SuiteShell, isShellEnabled } from '@levelup/ui-shell';
import { useSelector } from 'react-redux';
import { selectSwitchContextMeta } from '../store/slices/centralAuthSlice';
import { useShellAuth } from './hooks/useShellAuth';
import { MainLayout } from '../components/layout/MainLayout';

export function BeheardShellLayout() {
  const meta = useSelector(selectSwitchContextMeta);
  const { authSource } = useShellAuth();

  const shellEnabled = isShellEnabled({
    authSource,
    meta,
    forceUiShell: import.meta.env.VITE_FORCE_UI_SHELL === 'true',
  });

  if (shellEnabled) {
    return <SuiteShell />;
  }

  return <MainLayout />;
}
